(function () {
    var params = new URLSearchParams(window.location.search);
    var isEmbed = params.has('embed');

    var sim = document.getElementById('GridSimulator');
    var content = document.getElementById('GridDemoContent');

    // Embed mode: show only demo content (no simulator/help/footer sections).
    if (isEmbed) {
      if (sim) sim.parentNode.removeChild(sim);
      var cutoff = document.getElementById('GridHowToSection');
      if (cutoff && cutoff.parentNode) {
        var cursor = cutoff;
        while (cursor) {
          var next = cursor.nextElementSibling;
          if (cursor.tagName === 'SECTION') {
            cursor.parentNode.removeChild(cursor);
          }
          cursor = next;
        }
      }
      return;
    }

    if (!sim || !content) return;

    // Non-embed mode: simulator shell exists, but can be toggled on/off.
    sim.style.display = 'block';
    // content visibility is controlled by the "Simulator" toggle

    var frame = document.getElementById('GridSimulatorFrame');
    var frameWrap = document.getElementById('GridSimFrameWrap');
    var placeholder = document.getElementById('GridSimPlaceholder');

    var elRange = document.getElementById('GridSimWidth');
    var elNumber = document.getElementById('GridSimWidthNumber');
    var elAuto = document.getElementById('GridSimAuto');
    var elScale = document.getElementById('GridSimScaleToFit');
    var elEnabled = document.getElementById('GridSimEnabled');

    if (!elEnabled) return;

    var elMetaWidth = document.getElementById('GridSimMetaWidth');

    var elMetaBreakpoint = document.getElementById('GridSimMetaBreakpoint');
    var elMetaScale = document.getElementById('GridSimMetaScale');

    if (!frame || !frameWrap || !placeholder || !elRange || !elNumber || !elAuto || !elScale) return;

    // Load the same page into the iframe, but with ?embed=1 so it renders only the content.
    var url = new URL(window.location.href);
    url.searchParams.set('embed', '1');
    var frameSrc = url.toString();
    var frameLoaded = false;

    function ensureFrameLoaded() {
      if (frameLoaded) return;
      frame.src = frameSrc;
      frameLoaded = true;
    }

    // Mirror your SCSS breakpoints (used only for labeling).
    var BREAKPOINTS = [
      { name: 'default',       min: 0 },
      { name: 'phone',         min: 320 },
      { name: 'phone-large',   min: 480 },
      { name: 'tablet-small',  min: 600 },
      { name: 'tablet',        min: 768 },
      { name: 'tablet-large',  min: 900 },
      { name: 'desktop-small', min: 1024 },
      { name: 'desktop',       min: 1200 },
      { name: 'desktop-large', min: 1440 }
    ];

    function clamp(n, a, b) {
      return Math.max(a, Math.min(b, n));
    }

    function getBreakpointName(px) {
      var best = BREAKPOINTS[0].name;
      for (var i = 0; i < BREAKPOINTS.length; i++) {
        if (px >= BREAKPOINTS[i].min) best = BREAKPOINTS[i].name;
      }
      return best;
    }

    function loadState() {
      try {
        var raw = localStorage.getItem('grid_sim_state_v1');
        if (!raw) return null;
        return JSON.parse(raw);
      } catch (e) {
        return null;
      }
    }

    function saveState(state) {
      try {
        localStorage.setItem('grid_sim_state_v1', JSON.stringify(state));
      } catch (e) {}
    }

    function setDemoVisibility(showRealContent) {
      // If simulator lives inside GridDemoContent, only toggle sibling demo blocks.
      if (content.contains(sim)) {
        var kids = content.children;
        for (var i = 0; i < kids.length; i++) {
          if (kids[i] === sim) continue;
          kids[i].style.display = showRealContent ? '' : 'none';
        }
        content.style.display = 'block';
        return;
      }

      // Original behavior when simulator is outside demo content.
      content.style.display = showRealContent ? 'block' : 'none';
    }

    function applyEnabledState() {
      var enabled = !!elEnabled.checked;

      // When disabled: show real content, hide iframe area + width controls.
      if (!enabled) {
        setDemoVisibility(true);
        frameWrap.style.display = 'none';
        placeholder.style.display = 'block';

        // Disable controls that only matter when simulating
        elRange.disabled = true;
        elNumber.disabled = true;
        elAuto.disabled = true;
        elScale.disabled = true;

        // Meta: reflect real viewport
        if (elMetaWidth) elMetaWidth.textContent = window.innerWidth + 'px (real)';
        if (elMetaBreakpoint) elMetaBreakpoint.textContent = getBreakpointName(window.innerWidth);
        if (elMetaScale) elMetaScale.textContent = '100%';

        return;
      }

      // When enabled: hide real content, show iframe area + controls.
      setDemoVisibility(false);
      frameWrap.style.display = 'block';
      placeholder.style.display = 'none';

      elRange.disabled = false;
      elNumber.disabled = false;
      elAuto.disabled = false;
      elScale.disabled = false;

      ensureFrameLoaded();
      applyLayout();
    }

    function applyLayout() {
      var bar = sim.querySelector('.grid-sim__bar');
      var barH = bar ? bar.offsetHeight : 0;

      var auto = !!elAuto.checked;
      var scaleToFit = !!elScale.checked;

      var px = parseInt(elRange.value, 10);
      px = clamp(isFinite(px) ? px : 1200, 240, 2560);

      // Keep range/number in sync
      if (String(elNumber.value) !== String(px)) elNumber.value = px;

      // Determine the target width that the iframe viewport should be.
      // If Auto, make it equal to the available wrap width (baseline CSS behavior).
      var wrapW = frameWrap.clientWidth;
      var targetW = auto ? wrapW : px;

      // Compute an optional visual scale so you can see large widths on small screens.
      var scale = 1;
      if (scaleToFit && targetW > 0) {
        // small padding so it doesn't kiss the scrollbars
        var usable = Math.max(0, wrapW - 16);
        scale = usable > 0 ? Math.min(1, usable / targetW) : 1;
      }

      // Height: fill remaining viewport; if scaled, increase internal height so the visible area fills.
      var availH = Math.max(320, window.innerHeight - barH - 24);
      var innerH = Math.max(320, Math.floor(availH / Math.max(scale, 0.01)));

      frame.style.width = Math.floor(targetW) + 'px';
      frame.style.height = innerH + 'px';
      frame.style.transform = 'scale(' + scale.toFixed(4) + ')';

      // Meta
      if (elMetaWidth) elMetaWidth.textContent = Math.floor(targetW) + 'px' + (auto ? ' (auto)' : '');
      if (elMetaBreakpoint) elMetaBreakpoint.textContent = getBreakpointName(targetW);
      if (elMetaScale) elMetaScale.textContent = Math.round(scale * 100) + '%';

      saveState({
        enabled: !!elEnabled.checked,
        width: px,
        auto: auto,
        scaleToFit: scaleToFit
      });

    }

    function setWidth(px) {
      px = clamp(px, 240, 2560);
      elRange.value = String(px);
      elNumber.value = String(px);
      applyLayout();
    }

    // Restore last state (optional, but makes it feel "tool-like")
    var st = loadState();
    // Default: simulator OFF ALWAYS on load (user can enable manually)
    elEnabled.checked = false;

    if (st) {
      // NOTE: do NOT restore st.enabled; only restore other settings
      if (typeof st.auto === 'boolean') elAuto.checked = st.auto;
      if (typeof st.scaleToFit === 'boolean') elScale.checked = st.scaleToFit;
      if (typeof st.width === 'number') elRange.value = String(st.width);
    } else {
      elRange.value = String(Math.min(1200, Math.max(240, window.innerWidth)));
    }

    // Keep number synced before first paint
    elNumber.value = elRange.value;

    // Apply on/off state (and layout if enabled)
    applyEnabledState();

    // Events
    elEnabled.addEventListener('change', function () {
      applyEnabledState();
    });

    elRange.addEventListener('input', function () {
      if (!elEnabled.checked) return;
      // user moves slider => turn off auto
      elAuto.checked = false;
      setWidth(parseInt(elRange.value, 10));
    });

    elNumber.addEventListener('input', function () {
      if (!elEnabled.checked) return;
      elAuto.checked = false;
      setWidth(parseInt(elNumber.value, 10));
    });

    elAuto.addEventListener('change', function () {
      if (!elEnabled.checked) return;
      applyLayout();
    });
    elScale.addEventListener('change', function () {
      if (!elEnabled.checked) return;
      applyLayout();
    });
    window.addEventListener('resize', function () {
      // if disabled, keep meta accurate; if enabled, re-layout iframe.
      if (!elEnabled.checked) {
        if (elMetaWidth) elMetaWidth.textContent = window.innerWidth + 'px (real)';
        if (elMetaBreakpoint) elMetaBreakpoint.textContent = getBreakpointName(window.innerWidth);
        if (elMetaScale) elMetaScale.textContent = '100%';
        return;
      }
      applyLayout();
    });

  })();

